/**
 * Makes a base file name safe to use as an S3 filename.
 * 1. Replaces whitespace, periods, colons and forward slashes with '_'
 * 2. Removes anything that is not a word character or dash
 *
 * Word characters, `\w`, are equivalent in regex to: `[a-zA-Z0-9_]`
 *
 * Usage example: when creating an S3 key for an audio file, the user ID is used as the parent
 * folder, and the name of the audio file with timestamp is used as the filename within this folder.
 * If the user ID is 'XYZ' and the file is named 'my.awesome/track.final 1.mp3', we can use this
 * function to clean the base name (the filename minus the extension) and concatenate it with the
 * rest of the substrings to create the final S3 key. In that case, the final S3 key would be
 * something like: 'trqk-user-audio-files/XYZ/my_awesome_track_final_1.1231231.mp3'.
 *
 * @param {string} input
 */
export const sanitizeS3BaseName = (input: string): string =>
    input.replace(/[\s/.:]/gi, '_').replace(/[^\w-]/gi, '');
